import { component } from 'picoapp';
import app from 'app';  // eslint-disable-line

export default component((node) => {
  /**
   * Data + elements
   */
  const config = JSON.parse(node.dataset.config);
  const { productID, baseURL, limit } = config;

  const output = node.querySelector('.js-output');

  /**
   * Functions
   */
  const getMarkup = () => {
    const endpoint = `${baseURL}?section_id=product-related&product_id=${productID}&limit=${limit}`;
    return fetch(endpoint, {
      method: 'GET',
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
      },
    }).then((response) => response.text());
  };

  const init = async () => {
    const markup = await getMarkup();
    const container = document.createElement('div');
    container.innerHTML = markup;

    output.innerHTML = container.querySelector('.js-output').innerHTML;

    app.mount();
  };

  /**
   * Init
   */
  init();
});
